export const INITIAL_STATE = {
  rolesMap: {},
  roles: [],
  allPermissions: [],
  selectedRole: '',
  selectedPermissions: [],
  loadingData: true,
  saving: false,
  error: '',
  showConfirm: false,
  pendingPermission: null,
  autoUpdated: {},
  autoMessage: '',
};

const prettify = (value, prefix) =>
  value
    .replace(prefix, '')
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(' ');

export const formatRole = (role) => prettify(role, 'ROLE_');
export const formatPermission = (permission) => prettify(permission, '');

export const buildAutoMessage = (permission, changedKeys, isEnabling) => {
  if (!changedKeys.length) return '';
  const names = changedKeys.map((p) => `"${formatPermission(p)}"`).join(', ');
  const plural = changedKeys.length > 1;
  return isEnabling
    ? `${names} ${plural ? 'were' : 'was'} enabled automatically because "${formatPermission(
        permission
      )}" requires ${plural ? 'them' : 'it'}.`
    : `${names} ${plural ? 'were' : 'was'} removed automatically because ${
        plural ? 'they require' : 'it requires'
      } "${formatPermission(permission)}".`;
};
